/* =====================================================================
   Lisa Kookt - collectiepagina gedrag (concept-thema)
   - Verwijdert datum-sorteeropties
   - Bouwt op mobiel 2 knoppen: Filteren + Sorteren
   - Kort de introtekst in tot 1 zin met "Toon meer" (mobiel)
   - Subcategorie-knoppen (div.lk-subcats in de beschrijving): actieve knop
     groen, standaard alleen op voorraad, herhaald onderaan, en op desktop
     samen met de introtekst uitgelijnd met het productgrid
   ===================================================================== */
(function () {
  'use strict';
  var MOBILE = 749;
  function isMobile() { return window.innerWidth <= MOBILE; }

  /* 1. Datum-sorteeropties verwijderen uit alle sort-selects */
  function stripDateSorts() {
    var sels = document.querySelectorAll('select[name="sort_by"]');
    Array.prototype.forEach.call(sels, function (sel) {
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (o.value === 'created-ascending' || o.value === 'created-descending') {
          o.remove();
        }
      });
    });
  }

  /* 2. Mobiele Filteren/Sorteren knoppen */
  function buildMobileBar() {
    if (document.getElementById('lkMobileBar')) return;
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var drawerSummary = document.querySelector('.mobile-facets__wrapper summary');
    var sortSelect = document.querySelector('#SortBy-mobile') || document.querySelector('#SortBy');

    var bar = document.createElement('div');
    bar.id = 'lkMobileBar';
    bar.className = 'lk-mobilebar';

    if (drawerSummary) {
      var fb = document.createElement('button');
      fb.type = 'button';
      fb.className = 'lk-mbtn';
      fb.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg><span>Filteren</span>';
      fb.addEventListener('click', function () { drawerSummary.click(); });
      bar.appendChild(fb);
    }

    if (sortSelect) {
      var wrap = document.createElement('div');
      wrap.className = 'lk-mbtn-sort';
      var sbtn = document.createElement('button');
      sbtn.type = 'button';
      sbtn.className = 'lk-mbtn';
      sbtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18M6 12h12M10 18h4"></path></svg><span>Sorteren</span>';
      var menu = document.createElement('div');
      menu.className = 'lk-sortmenu';
      Array.prototype.slice.call(sortSelect.options).forEach(function (o) {
        if (o.value === 'created-ascending' || o.value === 'created-descending') return;
        var opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'lk-sortopt' + (o.selected ? ' is-active' : '');
        opt.textContent = (o.textContent || '').trim();
        opt.addEventListener('click', function () {
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', o.value);
          window.location.href = u.href;
        });
        menu.appendChild(opt);
      });
      sbtn.addEventListener('click', function (e) { e.stopPropagation(); wrap.classList.toggle('open'); });
      document.addEventListener('click', function () { wrap.classList.remove('open'); });
      wrap.appendChild(sbtn);
      wrap.appendChild(menu);
      bar.appendChild(wrap);
    }

    grid.parentNode.insertBefore(bar, grid);
  }

  /* 3. Introtekst inkorten tot 1 zin + Toon meer (alleen mobiel)
        De subcategorie-knoppen (div.lk-subcats) worden eerst apart gezet
        en na het inkorten weer onder de tekst teruggezet. */
  function truncateDescription() {
    if (!isMobile()) return;
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.dataset.lkDone) return;
    var chips = d.querySelector('.lk-subcats');
    if (chips) chips.parentNode.removeChild(chips);
    function restoreChips() { if (chips) d.appendChild(chips); }
    var text = (d.textContent || '').trim();
    if (!text) { restoreChips(); return; }
    var m = text.match(/[.!?](\s|$)/);
    if (!m) { restoreChips(); return; }
    var idx = m.index;
    if (idx >= text.length - 2) { restoreChips(); return; }
    d.dataset.lkDone = '1';
    var first = text.slice(0, idx + 1);
    var rest = text.slice(idx + 1).trim();
    d.textContent = '';
    var s1 = document.createElement('span');
    s1.textContent = first + ' ';
    var s2 = document.createElement('span');
    s2.className = 'lk-desc-rest';
    s2.textContent = rest;
    s2.hidden = true;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lk-desc-more';
    btn.textContent = 'Toon meer';
    btn.addEventListener('click', function () {
      var show = s2.hidden;
      s2.hidden = !show;
      btn.textContent = show ? 'Toon minder' : 'Toon meer';
    });
    d.appendChild(s1);
    d.appendChild(s2);
    d.appendChild(document.createTextNode(' '));
    d.appendChild(btn);
    restoreChips();
  }

  /* 3b. Subcategorie-knoppen: actieve knop (groen) markeren o.b.v. filter in de URL.
        De filterwaarde(n) worden uit de href van de knop zelf gelezen, zodat het
        ook werkt als de rich-text editor data-attributen heeft gestript. Een knop
        mag meerdere producttypes tegelijk filteren (bijv. "Overig").
        Categorie-knoppen krijgen standaard het filter "op voorraad" mee. */
  function markActiveSubcat() {
    var box = document.querySelector('.lk-subcats');
    if (!box) return;
    var KEY = 'filter.p.product_type';
    function key(list) { return list.slice().sort().join('|'); }
    var cur = key(new URLSearchParams(window.location.search).getAll(KEY));
    Array.prototype.forEach.call(box.querySelectorAll('a[href]'), function (a) {
      var vals, u;
      try { u = new URL(a.getAttribute('href'), window.location.origin); vals = u.searchParams.getAll(KEY); }
      catch (err) { return; }
      var t = key(vals);
      if (t && !u.searchParams.has('filter.v.availability')) {
        u.searchParams.append('filter.v.availability', '1');
        a.setAttribute('href', u.pathname + u.search);
      }
      if (t === cur) {
        a.style.background = '#8a957f';
        a.style.borderColor = '#8a957f';
        a.style.color = '#fff';
        a.setAttribute('aria-current', 'true');
      }
    });
  }

  /* 3c. Subcategorie-knoppen ook onderaan, boven het "Verder kijken"-blok.
        Titel per collectie-handle instelbaar in `titles`. */
  function cloneSubcatBottom() {
    var box = document.querySelector('.lk-subcats');
    var more = document.querySelector('.lk-more');
    if (!box || !more || document.querySelector('.lk-subcats-bottom')) return;
    var wrap = document.createElement('div');
    wrap.className = 'lk-subcats-bottom';
    wrap.style.cssText = 'margin:28px 0 4px;padding:0;';
    var title = document.createElement('p');
    title.style.cssText = 'margin:0 0 10px;font-size:15px;font-weight:600;color:#2b2b2b;';
    var titles = {
      'snacks-tussendoortjes': 'Snel naar een andere snack categorie',
      'diner': 'Snel naar een andere diner categorie',
      'ontbijt-lunch': 'Snel naar een andere ontbijt en lunch categorie',
      'sauzen': 'Snel naar een andere saus categorie',
      'chocolade': 'Snel naar een andere chocolade categorie',
      'snoepjes': 'Snel naar snoepjes of koekjes'
    };
    var handle = (window.location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1] || '';
    title.textContent = titles[handle] || 'Snel naar een andere categorie';
    var clone = box.cloneNode(true);
    clone.classList.remove('lk-subcats');
    clone.classList.add('lk-subcats-clone');
    wrap.appendChild(title);
    wrap.appendChild(clone);
    more.parentNode.insertBefore(wrap, more);
  }

  /* 3d. Desktop: introtekst + knoppenrij uitlijnen met de linkerrand van het productgrid.
        De inspringing staat al in CSS (snippets/lk-pakket-kaarttitel.liquid, 286px vanaf
        768px en 334px vanaf 992px), zodat de tekst meteen op de goede plek staat en niet
        verspringt. Dit script corrigeert alleen als het grid toch ergens anders begint
        (bijv. een collectie zonder filterkolom). */
  function alignSubcatDesktop() {
    var box = document.querySelector('.lk-subcats');
    if (!box) return;
    var desc = box.closest('.collection-hero__description') || box;
    function apply() {
      desc.style.marginLeft = '';
      if (isMobile()) return;
      var grid = document.getElementById('ProductGridContainer');
      if (!grid) return;
      var diff = grid.getBoundingClientRect().left - desc.getBoundingClientRect().left;
      if (Math.abs(diff) > 1) {
        var cur = parseFloat(window.getComputedStyle(desc).marginLeft) || 0;
        desc.style.marginLeft = Math.max(0, Math.round(cur + diff)) + 'px';
      }
    }
    apply();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 120); });
  }

  /* 4. Filter-drawer: kruisje + swipe-to-close + klik-buiten + chips */
  function enhanceFilterDrawer() {
    var wrapper = document.querySelector('.mobile-facets__wrapper');
    if (!wrapper) return;
    var details = wrapper.querySelector('details');
    var summary = wrapper.querySelector('summary');
    var inner = wrapper.querySelector('.mobile-facets__inner');
    var header = wrapper.querySelector('.mobile-facets__header-inner') || wrapper.querySelector('.mobile-facets__header');
    if (!details || !summary || !inner) return;

    function closeDrawer() { if (details.open) summary.click(); }

    /* "Filteren en sorteren" -> "Filteren" (sorteren zit nu apart) */
    Array.prototype.forEach.call(wrapper.querySelectorAll('.mobile-facets__heading'), function (h) {
      if (/sorteren/i.test(h.textContent)) h.textContent = 'Filteren';
    });

    /* Kruisje rechtsboven */
    if (header && !header.querySelector('.lk-drawer-close')) {
      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'lk-drawer-close';
      x.setAttribute('aria-label', 'Filter sluiten');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="28" height="28" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
      x.addEventListener('click', closeDrawer);
      header.appendChild(x);
    }

    /* Swipe naar rechts om te sluiten (drawer komt van rechts) */
    if (!inner.dataset.lkSwipe) {
      inner.dataset.lkSwipe = '1';
      var startX = null, startY = null;
      inner.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; startX = t.clientX; startY = t.clientY;
      }, { passive: true });
      inner.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX, dy = t.clientY - startY;
        if (dx > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) closeDrawer();
        startX = null;
      }, { passive: true });
    }

    /* Klik op de resterende ~1/5 (buiten het paneel) sluit de drawer,
       zonder dat het product eronder wordt geopend. */
    if (!document.documentElement.dataset.lkOutside) {
      document.documentElement.dataset.lkOutside = '1';
      document.addEventListener('click', function (e) {
        if (!details.open) return;
        if (inner.contains(e.target) || summary.contains(e.target)) return;
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }, true);
    }

    /* Geselecteerde filterwaarden tonen onder elke filter */
    renderSelectedChips(wrapper);
    if (!wrapper.dataset.lkChips) {
      wrapper.dataset.lkChips = '1';
      wrapper.addEventListener('change', function () { renderSelectedChips(wrapper); });
    }
  }

  function renderSelectedChips(wrapper) {
    Array.prototype.forEach.call(wrapper.querySelectorAll('.mobile-facets__details'), function (det) {
      var summary = det.querySelector('.mobile-facets__summary');
      if (!summary) return;
      var labels = [];
      Array.prototype.forEach.call(det.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked'), function (inp) {
        var lab = null;
        if (inp.id) {
          try { lab = det.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]'); }
          catch (err) { lab = null; }
        }
        var txt = lab ? lab.textContent : inp.value;
        txt = (txt || '').replace(/\s+/g, ' ').trim();
        txt = txt.split('(')[0].trim();
        if (txt && labels.indexOf(txt) === -1) labels.push(txt);
      });
      var priceInputs = det.querySelectorAll('input[name*="price"]');
      if (priceInputs.length >= 2 && (priceInputs[0].value || priceInputs[1].value)) {
        labels.push('€' + (priceInputs[0].value || '0') + ' - €' + (priceInputs[1].value || '…'));
      }
      var old = det.querySelector('.lk-selected-chips');
      if (old) old.remove();
      if (labels.length) {
        var box = document.createElement('div');
        box.className = 'lk-selected-chips';
        labels.forEach(function (l) {
          var c = document.createElement('span');
          c.className = 'lk-chip';
          c.textContent = l;
          box.appendChild(c);
        });
        summary.insertAdjacentElement('afterend', box);
      }
    });
  }

  function init() {
    stripDateSorts();
    buildMobileBar();
    truncateDescription();
    markActiveSubcat();
    cloneSubcatBottom();
    alignSubcatDesktop();
    enhanceFilterDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
